module.exports = __webpack_public_path__ + "static/media/downloadCsv.fed80e41.svg";